// @ts-nocheck
import constants from "@store/constants";
import { getBlogMostRecent, GetBlogMostRecentApiParameter } from "@store/Framework/Services/BlogService";
import { BlogMostRecentCollectionModel } from "@store/Framework/Types/ApiModels";
import { ApiHandler, createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";
import { getContextData } from "@toolkit/Modules/client-framework/Store/Data/Pages/PagesActionCreators";

type HandlerType = ApiHandler<GetBlogMostRecentApiParameter, BlogMostRecentCollectionModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter, type: constants.blog.getDataViewType.mostRecent } as any; // 'type' is neccessary to differentiate dataView (cache) keys
};

export const DispatchBeginLoadBlogMostRecent: HandlerType = props => {
    props.dispatch({
        type: "Data/Pages/BeginLoadPages",
        parameter: props.apiParameter as any,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getBlogMostRecent(props.apiParameter);
};

export const DispatchCompleteLoadBlogMostRecent: HandlerType = props => {
    const state = props.getState();

    props.dispatch({
        type: "Data/Pages/CompleteLoadPages",
        parameter: props.apiParameter as any,
        collection: {
            pages: props.apiResult.pages,
            pagination: {} as any,
        },
        links: state.links,
        ...getContextData(state),
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadBlogMostRecent,
    RequestDataFromApi,
    DispatchCompleteLoadBlogMostRecent,
];

const loadBlogMostRecent = createHandlerChainRunner(chain, "LoadBlogMostRecent");
export default loadBlogMostRecent;
